import React from 'react';
import {Table as ClassicTable} from './classic';
import {Table as TiersTable} from './tiers';
import {Table as ShowDownTable} from './showdown';

const PlayersList = {
    get(sportConfig) {
        if (sportConfig.isGameTypeTiers()) {
            return TiersTable;
        } else if (sportConfig.isGameTypeShowDown()) {
            return ShowDownTable;
        } else if (sportConfig.isGameTypeClassic()) {
            return ClassicTable;
        }

        throw new Error(`get ERR: unknown game type ${sportConfig.getGameType()}`);
    },
};

export {PlayersList};
